require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[44],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(402);


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _ProgressIndicator = _interopRequireDefault(__webpack_require__(403));

exports["default"] = _ProgressIndicator["default"];
exports.ProgressIndicator = _ProgressIndicator["default"];

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = exports.DEFAULT_DELAY = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

var _Tooltip = _interopRequireDefault(__webpack_require__(75));

__webpack_require__(404);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes,
    sanitize = _utils.propsUtils.sanitize;
var DEFAULT_DELAY = 250;
exports.DEFAULT_DELAY = DEFAULT_DELAY;

var ProgressIndicator = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ProgressIndicator, _Component);

  function ProgressIndicator() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inlineRender", function () {
      var _this$props$inlineOpt = _this.props.inlineOptions,
          status = _this$props$inlineOpt.status,
          iconDescription = _this$props$inlineOpt.iconDescription,
          onSuccess = _this$props$inlineOpt.onSuccess;

      if (_this.context.pureCarbon) {
        return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.InlineLoading, _this.props);
      }

      var inlineProps = {
        status: status,
        description: _this.props.description,
        iconDescription: iconDescription,
        onSuccess: onSuccess
      };
      return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.InlineLoading, (0, _extends2["default"])({}, _this._getProgressProps(), inlineProps));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_circleRender", function () {
      var _this$props = _this.props,
          size = _this$props.size,
          withOverlay = _this$props.withOverlay,
          active = _this$props.active,
          description = _this$props.description;
      var circleProps = {
        small: size === 'small' || size === 'normal',
        withOverlay: withOverlay,
        active: active,
        description: description
      };
      return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Loading, (0, _extends2["default"])({}, _this._getProgressProps(), circleProps));
    });
    return _this;
  }

  var _proto = ProgressIndicator.prototype;

  _proto._isDeterminate = function _isDeterminate() {
    return this.props.progress != null;
  };

  _proto._getProgressProps = function _getProgressProps() {
    var _this$props2 = this.props,
        tabIndex = _this$props2.tabIndex,
        className = _this$props2.className,
        style = _this$props2.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["tabIndex", "className", "style"]);
    var props = (0, _extends2["default"])({}, sanitize(others, ProgressIndicator), {
      tabIndex: tabIndex === 0 ? 0 : null,
      role: 'progressbar',
      className: className,
      style: style
    });
    return props;
  };

  _proto._barRender = function _barRender() {
    var _this$props3 = this.props,
        variant = _this$props3.variant,
        className = _this$props3.className;
    var classNames = (0, _utils.classnames)(className, variant);
    return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      id: "tooltip-bottom",
      title: this._isDeterminate() ? this.props.progress + "%" : 'indeterminate',
      disabled: !this._isDeterminate(),
      orient: "bottom",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, this._getProgressProps(), {
      className: classNames
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "ba-common-progressIndicator__determinateFiller"
    })));
  };

  _proto.render = function render() {
    var variant = this.props.variant;
    return this["_" + variant + "Render"]();
  };

  return ProgressIndicator;
}(_react.Component);

(0, _defineProperty2["default"])(ProgressIndicator, "propTypes", {
  /** If the element can be focused witht the tab key */
  tabIndex: _propTypes["default"].oneOf([-1, 0]),

  /** Choose from fixed sizes */
  variant: _propTypes["default"].oneOf(['circle', 'bar', 'inline']),

  /** Choose from fixed sizes */
  size: _propTypes["default"].oneOf(['small', 'normal', 'large']),

  /** ( Temporarily deprecated ) Used when determinate is true to indicate progress stage */
  progress: BaPropTypes.range(0, 100),

  /** Specify an description that would be used to best describe the loading state */
  description: _propTypes["default"].string,

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Custom CSS styles */
  style: _propTypes["default"].object,

  /** ( Temporarily deprecated ) Display progress updates */
  determinate: _propTypes["default"].bool,

  /** Specify whether you want the loading indicator to be spinning or not */
  active: _propTypes["default"].bool,

  /** Specify whether you want the loader to be applied with an overlay */
  withOverlay: _propTypes["default"].bool,

  /** Additional props (status, iconDescription, onSuccess) for inline varirant */
  inlineOptions: _propTypes["default"].shape({
    status: _propTypes["default"].oneOf(['inactive', 'active', 'finished', 'error']),
    iconDescription: _propTypes["default"].string,

    /** Optional callback function to be invoked when complete  */
    onSuccess: _propTypes["default"].func
  })
});
(0, _defineProperty2["default"])(ProgressIndicator, "defaultProps", {
  tabIndex: -1,
  size: 'normal',
  determinate: false,
  variant: 'circle',
  description: '',
  className: '',
  style: {},
  active: true,
  withOverlay: false
});

var _default = (0, _utils.delayMount)(DEFAULT_DELAY)(ProgressIndicator);

exports["default"] = _default;

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(405);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "@keyframes ba-common-progressIndicator_bar_before{0%{left:-100%}100%{left:0}}@keyframes ba-common-progressIndicator_bar_after{0%{left:0}100%{left:100%}}.is-bar{background-color:#e0e0e0;width:100%;height:4px;position:relative;overflow:hidden;outline:1px solid transparent}.is-bar .ba-common-progressIndicator__determinateFiller{border-width:4px;border-style:solid}.is-bar:not(.is-determinate) .ba-common-progressIndicator__determinateFiller{border-style:none;width:50%;border-color:#0f62fe}.is-bar:not(.is-determinate) .ba-common-progressIndicator__determinateFiller:before,.is-bar:not(.is-determinate) .ba-common-progressIndicator__determinateFiller:after{position:absolute;animation:ba-common-progressIndicator_bar_after 1s linear infinite;content:'';width:50%;border-width:4px;border-style:solid;border-color:#0f62fe}.is-bar:not(.is-determinate) .ba-common-progressIndicator__determinateFiller:before{animation:ba-common-progressIndicator_bar_before 1s linear infinite}\n", ""]);

// exports


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _utils = __webpack_require__(4);

var _TooltipPopup = _interopRequireDefault(__webpack_require__(76));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize;

var tooltipPopupClassName = _TooltipPopup["default"].tooltipPopupClassName.replace(/"/g, '');

var TooltipPopup = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TooltipPopup, _Component);

  function TooltipPopup(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._box = node;
    });
    _this.tooltip = document.createElement('div');
    _this.state = {
      isIE: window.navigator.userAgent.indexOf('Edge') > -1 || !!window.MSInputMethodContext && !!document.documentMode
    };
    return _this;
  }

  var _proto = TooltipPopup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.body.appendChild(this.tooltip);

    this._updatePosition();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.availableSpace !== this.props.availableSpace) {
      this._updatePosition();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.body.removeChild(this.tooltip);
  };

  _proto._updatePosition = function _updatePosition() {
    if (this.props.availableSpace) {
      this.newOrient = _utils.domUtils.autoPosition(this.props.availableSpace, {
        height: this._box.clientHeight + 10,
        width: this.state.isIE ? 200 : this._box.firstChild.clientWidth
      }, this.props.orient);
    }

    var actualOrient = this.newOrient ? this.newOrient : this.props.orient;

    var tooltipStyle = this._getStyle(this._box.getBoundingClientRect().width, actualOrient);

    this._box.setAttribute('style', "top: " + tooltipStyle.top + "px; left: " + tooltipStyle.left + "px; min-width: " + this._box.getBoundingClientRect().width + "px");
  };

  _proto._getStyle = function _getStyle(tooltipBoxWidth, orient) {
    var _this2 = this;

    var orientsList = [(0, _utils.classnames)('top'), (0, _utils.classnames)('right'), (0, _utils.classnames)('bottom'), (0, _utils.classnames)('left')];
    orientsList.map(function (item) {
      return _this2.tooltip.firstElementChild.classList.remove(item);
    });
    this.tooltip.firstElementChild.classList.add((0, _utils.classnames)(orient));
    var triggerState = this.props.triggerState;
    var tooltipStyle;

    if (orient === 'left') {
      tooltipStyle = {
        left: -parseInt(tooltipBoxWidth, 10),
        top: parseInt(triggerState.height, 10) / 2
      };
    } else if (orient === 'right') {
      tooltipStyle = {
        left: parseInt(triggerState.width, 10),
        top: parseInt(triggerState.height, 10) / 2
      };
    } else if (orient === 'top') {
      tooltipStyle = {
        top: 0,
        left: parseInt(triggerState.width, 10) / 2
      };
    } else {
      tooltipStyle = {
        top: parseInt(triggerState.height, 10),
        left: parseInt(triggerState.width, 10) / 2
      };
    }

    return tooltipStyle;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        title = _this$props.title,
        triggerState = _this$props.triggerState,
        style = _this$props.style,
        popupWidth = _this$props.popupWidth,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "title", "triggerState", "style", "popupWidth"]);
    var containerWidth = this.state.isIE ? Math.min(parseInt("" + (window.innerWidth - (triggerState.left || 0)), 10), 200) : parseInt("" + (triggerState.width || 0), 10);
    return _reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, TooltipPopup), {
      className: tooltipPopupClassName + "__container " + className,
      style: (0, _extends2["default"])({
        top: parseInt("" + (triggerState.top || 0), 10),
        left: parseInt("" + (triggerState.left || 0), 10),
        width: containerWidth,
        maxWidth: popupWidth
      }, style)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: tooltipPopupClassName + "__box",
      ref: this._ref,
      style: {
        minWidth: popupWidth
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: tooltipPopupClassName + "__content"
    }, title))), this.tooltip);
  };

  return TooltipPopup;
}(_react.Component);

exports["default"] = TooltipPopup;
(0, _defineProperty2["default"])(TooltipPopup, "propTypes", {
  orient: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  triggerState: _propTypes["default"].object,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  availableSpace: _propTypes["default"].object,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  popupWidth: _propTypes["default"].string
});
(0, _defineProperty2["default"])(TooltipPopup, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _TooltipPopup = _interopRequireDefault(__webpack_require__(55));

var _Tooltip = _interopRequireDefault(__webpack_require__(78));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var tooltipClassName = _Tooltip["default"].tooltipClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;
var isKey = _utils.keyboardUtils.isKey,
    keyNames = _utils.keyboardUtils.keyNames;
var DEFAULT_DELAY_TIME = 800;

var Tooltip = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Tooltip, _Component);

  function Tooltip() {
    var _this;

    _this = _Component.call(this) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      hover: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      isKey(e, keyNames.ESCAPE) && _this.setState({
        hover: false
      }, _this._clearTimer);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseEnter", function () {
      _this._resetStates();

      var delay = _this.props.delay;
      var newState = (0, _extends2["default"])({
        hover: true
      }, delay ? {
        hidden: true
      } : {});
      document.addEventListener('keydown', _this._onKeyDown, false);

      _this.setState(newState, delay && _this._setTimer);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseDown", function (e) {
      var elementOnMouse = document.elementFromPoint && document.elementFromPoint(e.clientX, e.clientY);

      if (elementOnMouse && _this.trigger.current !== elementOnMouse) {
        _this.setState({
          hover: false
        }, _this._clearTimer);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onMouseLeave", function () {
      _this.setState({
        hover: false
      }, _this._clearTimer);
    });
    _this.handleHashChange = _this.handleHashChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.trigger = (0, _react.createRef)();
    return _this;
  }

  var _proto = Tooltip.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('hashchange', this.handleHashChange);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._clearTimer();

    window.removeEventListener('hashchange', this.handleHashChange);
  };

  _proto.handleHashChange = function handleHashChange() {
    this.setState({
      hover: false
    }, this._clearTimer);
  };

  _proto._setTimer = function _setTimer() {
    var _this2 = this;

    var delay = this.props.delay;
    var time;

    if (typeof delay === 'number') {
      time = delay;
    } else {
      time = DEFAULT_DELAY_TIME;
    }

    this.timer = setTimeout(function () {
      _this2.setState({
        hidden: false
      });
    }, time);
  };

  _proto._clearTimer = function _clearTimer() {
    var delay = this.props.delay;
    document.removeEventListener('keydown', this._onKeyDown, false);

    if (delay && this.timer) {
      clearTimeout(this.timer);
    }
  };

  _proto._resetStates = function _resetStates() {
    this.setState({
      top: _utils.domUtils.computeTopWith(this.trigger.current),
      left: _utils.domUtils.computeLeftWith(this.trigger.current),
      width: this.trigger.current.clientWidth,
      height: this.trigger.current.clientHeight,
      availableSpace: _utils.domUtils.availableSpace(this.trigger.current)
    });
  };

  _proto.render = function render() {
    // update orient by calling autoposition
    var _this$props = this.props,
        display = _this$props.display,
        orient = _this$props.orient,
        title = _this$props.title,
        children = _this$props.children,
        className = _this$props.className,
        style = _this$props.style,
        disabled = _this$props.disabled,
        popupWidth = _this$props.popupWidth,
        textDir = _this$props.textDir,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["display", "orient", "title", "children", "className", "style", "disabled", "popupWidth", "textDir"]);
    var _this$state = this.state,
        top = _this$state.top,
        left = _this$state.left,
        width = _this$state.width,
        height = _this$state.height;
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, Tooltip), {
      ref: this.trigger,
      className: tooltipClassName + " " + className,
      style: (0, _extends2["default"])({
        display: display
      }, style),
      onMouseEnter: this._onMouseEnter,
      onMouseLeave: this._onMouseLeave,
      onMouseDown: this._onMouseDown
    }), children, title != null && title !== '' && this.state.hover && !this.state.hidden && !disabled && /*#__PURE__*/_react["default"].createElement(_TooltipPopup["default"], {
      orient: orient,
      title: title,
      textDir: textDir,
      availableSpace: this.state.availableSpace,
      triggerState: {
        top: top,
        left: left,
        width: width,
        height: height
      },
      popupWidth: popupWidth
    }));
  };

  return Tooltip;
}(_react.Component);

exports["default"] = Tooltip;
(0, _defineProperty2["default"])(Tooltip, "propTypes", {
  display: _propTypes["default"].oneOf(['block', 'inline-block']),
  orient: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  children: _propTypes["default"].node,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  delay: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number]),
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  style: _propTypes["default"].object,

  /** Specifies the width of the tooltip popup */
  popupWidth: _propTypes["default"].string
});
(0, _defineProperty2["default"])(Tooltip, "defaultProps", {
  orient: 'bottom',
  display: 'inline-block',
  className: '',
  style: {}
});

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(77);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-carbon-tooltip-popup__container{user-select:none;font-weight:normal;font-size:11px;line-height:13px;position:absolute;z-index:999999;max-width:160px;text-align:center;min-height:20px;pointer-events:none}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box{min-width:100px;max-width:160px;position:absolute;pointer-events:none;height:inherit}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box .ba-common-carbon-tooltip-popup__content{min-width:100px;max-width:160px;width:max-content;padding:8px;font-weight:600;font-size:12px;display:inline-block;border:1px solid transparent;background-color:#393939;color:#fff;box-shadow:0 2px 8px 0 rgba(0,0,0,0.1);position:relative;line-height:16px;overflow-wrap:break-word;word-wrap:break-word}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box .ba-common-carbon-tooltip-popup__content::after{clear:all}.ba-common-carbon-tooltip-popup__container.is-top .ba-common-carbon-tooltip-popup__box{transform:translateX(-50%) translateY(-100%) translateY(-8px)}.ba-common-carbon-tooltip-popup__container.is-bottom .ba-common-carbon-tooltip-popup__box{transform:translateX(-50%) translateY(8px)}.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box{transform:translateX(-8px) translateY(-50%)}.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box .ba-common-carbon-tooltip-popup__content{float:right}.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box{transform:translateX(8px) translateY(-50%)}.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box .ba-common-carbon-tooltip-popup__content{float:left}.ba-common-carbon-tooltip-popup__container.is-top .ba-common-carbon-tooltip-popup__box:before{content:'';position:absolute;margin-top:-5px;border-width:5px;border-style:solid;bottom:0;left:50%;transform:translateX(-50%) translateY(100%)}.ba-common-carbon-tooltip-popup__container.is-bottom .ba-common-carbon-tooltip-popup__box:before{content:'';position:absolute;margin-top:-5px;border-width:5px;border-style:solid;top:0;left:50%;transform:translateX(-50%) translateY(-50%)}.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box:before{content:'';position:absolute;margin-top:-5px;border-width:5px;border-style:solid;right:0;top:50%;-webkit-transform:translateX(100%);transform:translateX(100%)}.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box:before{content:'';position:absolute;margin-top:-5px;border-width:5px;border-style:solid;left:0;top:50%;transform:translateX(-100%)}.ba-common-carbon-tooltip-popup__container{transition:opacity .2s ease-in-out,transform .2s ease-in-out}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box{background-color:#343334;color:#fff;box-shadow:0 2px 8px 0 rgba(0,0,0,0.1)}.ba-common-carbon-tooltip-popup__container.is-top .ba-common-carbon-tooltip-popup__box:before{border-color:#343334 transparent transparent transparent}@media screen and (-ms-high-contrast: active){.ba-common-carbon-tooltip-popup__container.is-top .ba-common-carbon-tooltip-popup__box:before{border-color:#fff #000 #000 #000}}.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box:before{border-color:transparent #343334 transparent transparent}@media screen and (-ms-high-contrast: active){.ba-common-carbon-tooltip-popup__container.is-right .ba-common-carbon-tooltip-popup__box:before{border-color:#000 #fff #000 #000}}.ba-common-carbon-tooltip-popup__container.is-bottom .ba-common-carbon-tooltip-popup__box:before{border-color:transparent transparent #343334 transparent}@media screen and (-ms-high-contrast: active){.ba-common-carbon-tooltip-popup__container.is-bottom .ba-common-carbon-tooltip-popup__box:before{border-color:#000 #000 #fff #000}}.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box:before{border-color:transparent transparent transparent #343334}@media screen and (-ms-high-contrast: active){.ba-common-carbon-tooltip-popup__container.is-left .ba-common-carbon-tooltip-popup__box:before{border-color:#000 #000 #000 #fff}}\n", ""]);

// exports
exports.locals = {
	"tooltipPopupClassName": "\"ba-common-carbon-tooltip-popup\""
};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(79);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-tooltip{position:relative}.ba-common-tooltip [disabled]{pointer-events:none}.ba--highContrast .ba-common-tooltip__container:before{border-style:none}\n", ""]);

// exports
exports.locals = {
	"tooltipClassName": "\"ba-common-tooltip\""
};

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[401,0]]]);
});